import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from '../../../../profile/store/profile.entity';
import { ProfileService } from '../../../../profile/providers/profile.service';

@Component({
    selector: 'app-payment-tab',
    templateUrl: './payment-tab.component.html',
    styleUrls: ['./payment-tab.component.scss', '../../../tabs.scss']
})
export class PaymentTabComponent {
    profileData$: Observable<Profile>;

    constructor(private profileService: ProfileService) {
        this.profileData$ = this.profileService.getCurrentProfileDataObserver();
    }
}
